export const playbooksPath = 'api/landlord/playbooks';
